<template>
  <div style="text-align: center">
    <el-button type="primary" @click="getResults" icon="el-icon-view" :loading="loadingInitialResults">Get Results</el-button>
  </div>
</template>

<script>
  export default {
    data(){
      return {
        mppData:'',
        loadingInitialResults: false
      }
    },
    methods: {
      getResults(){
        this.loadingInitialResults = true;


        //call global function (an action in the vuex store)
        this.$store.dispatch('setMPPFetchingResultsNow', true);
        this.$store.dispatch('globalActionMPPFetchResults', this.mppData).then((response) => {
          //console.log(response);
          this.loadingInitialResults = false;
        });


      }
    },
    computed: {

    },
    created(){

    }
  }
</script>

<style scoped lang="scss">

</style>